import { BUSINESS_CLASSIFICATION, COMPANY_TYPE } from '../const/app.const';
import { FormlySelectOption } from '@ngx-formly/core/select';
import { AuthorizedPersonnelModel, BeneficialOwnerModel, UsPersonModel } from '../model';

export type BusinessClassification = typeof BUSINESS_CLASSIFICATION[number];
export type CompanyType = typeof COMPANY_TYPE[number];

export enum PersonnelEntityState {
  'New' = 'new',
  'Existed' = 'existed',
}

export type AuthorizedPersonnelOption = FormlySelectOption & {
  value: string | null;
  personnel?: AuthorizedPersonnelModel | null;
};

export type BeneficialOwnerOption = FormlySelectOption & {
  value: string | null;
  beneficialOwner: AuthorizedPersonnelModel | BeneficialOwnerModel | null;
};

export type UsPersonOption = FormlySelectOption & {
  value: string | null;
  usPerson: AuthorizedPersonnelModel | UsPersonModel | null;
};
